import { personalNumberValid, orgNumberValid } from 'mrshoebox-ui-components/src/helpers/countrySpecific'

export const required = value => !value ? true : undefined
export const min = (num) => (value = '') => value.length <= num ? true : undefined

export const isCorrectOrgNumber = (value) => !orgNumberValid(value)
export const isCorrectPersonalNumber = (value) => !personalNumberValid(value)
